







import VueOptions from '@utils/VueOptions'
import Timeline from '@modules/ui/components/Timeline'
import Stats from '@modules/ui/components/Stats'

settings =
  name: 'SuperContainerView'
  components: { Timeline, Stats }
  vue:
    props: ['arc', 'stats']
    beforeDestroy: ->
      # window.stop()
      @requestIsPending = false

export default VueOptions.vue settings
